import { enumParser } from '#validation/common/parsers';
import { FilespaceStatus } from '../constants';
export const filespaceStatusParser = enumParser(FilespaceStatus);
